import React from 'react';

const BannerDiscount = ({title, button, url, date}) => {

	const isEnd = () => {
		if (!date) {
			return false;
		}

		var d = new Date();
		d.setHours(0,0,0,0);

		return d >= new Date(date.replace(/-/g, '/'));
	}

	if (isEnd()) {
		return '';
	}

	return (
		<div className="discount-banner-cta">
			<div className="discount-banner-cta__wrap">
				<h3 className="discount-banner-cta__title">{title}</h3>
				<div className="discount-banner-cta__line"></div>
				<a href={url} className="discount-banner-cta__link">{button}</a>
			</div>
		</div>
	);
};

export default BannerDiscount;